import React, { useState } from "react";
import styled from "styled-components";
import Button from "@mui/material/Button";
import ShopperProfile from "../ShopperProfile";
import { api } from "../../maps/data.js";
import IconBtn from "../IconBtn";
import ShopperAddDialog from "../../components/dialogs/ShopperAddDialog";

const WrapperStyled = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

const ShopperListContainerStyled = styled.div`
  display: block;
  overflow-y: auto;
  height: 86vh;
  padding-bottom: 5px;
  text-align: center;
`;
const ShopperCheckinDrawer = (props) => {
  const {
    allShoppersAsMapObj,
    shopperOnline_list,
    shopperToSimulate,
    simulateSteps,
    s_shopperToSimulate,
    stats_mode,
    stats,
    siteId,
    s_stats,
    s_stats_mode,
    shoppersToDisplay,
    removeAllShoppersOnlineHandle,
  } = props;

  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [editShopper, setEditShopper] = useState(null);


  return (
    <WrapperStyled>
      <div>
        
        <div style={{ textAlign: "center", marginBottom: 20 }}>
          <b>Online ({shopperOnline_list?.length || 0})</b>
          <span onClick={removeAllShoppersOnlineHandle}>
            <IconBtn
              customtheme="small-gray"
              size="small"
              style={{ marginLeft: 5 }}
            >
              delete
            </IconBtn>
          </span>
        </div>
        <ShopperListContainerStyled>
          {allShoppersAsMapObj &&
            shopperOnline_list.map((shopperOnline, idx) => {
              const shopper = allShoppersAsMapObj[shopperOnline.shopperId];
              if (!shopper) {
                return null;
              }
              return (
                <ShopperProfile
                  shopper={shopper}
                  key={shopper._id + "shopperOnline"}
                  isActive={shopperToSimulate?._id === shopperOnline.shopperId}
                  onClick={() => {
                    if (simulateSteps) {
                      s_shopperToSimulate(shopper);
                    } else {
                      api({
                        type: "siteCheckout",
                        data: {
                          userId: shopper._id,
                          siteId,
                        },
                      });
                    }
                  }}
                  stats={
                    stats_mode && (
                      <div>
                        <div>
                          CNN ACC: -{" "}
                          {(
                            (stats[shopper._id] / stats.totalCnn) *
                            100
                          ).toFixed(1)}
                          % ({stats[shopper._id]} / {Math.floor(stats.totalCnn)}
                          )
                        </div>

                        <div>
                          Key ACC: -{" "}
                          {(
                            (stats[`${shopper._id}_key`] / stats.totalKey) *
                            100
                          ).toFixed(1)}
                          % ({stats[`${shopper._id}_key`]} /{" "}
                          {Math.floor(stats.totalKey)})
                        </div>
                        <div>
                          Fusion ACC: -{" "}
                          {(
                            (stats[`${shopper._id}_fusion`] /
                              stats.totalFusion) *
                            100
                          ).toFixed(1)}
                          % ({stats[`${shopper._id}_fusion`]} /{" "}
                          {Math.floor(stats.totalFusion)})
                        </div>
                      </div>
                    )
                  }
                />
              );
            })}

          <Button
            variant="contained"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();

              let _stats = {
                noUserId: 0,
                total: 0.01,
                totalDetected: 0.01,
                totalCnn: 0.01,
                totalFusion: 0.01,
                totalKey: 0.01,
              };
              shopperOnline_list.forEach(
                (shopper) => (_stats[shopper.shopperId] = 0)
              );
              s_stats(_stats);
              s_stats_mode(true);
            }}
          >
            init stats
          </Button>

          {stats_mode && (
            <div>
              no user id prdictions:{" "}
              {parseInt((stats.noUserId / stats.total) * 100)}%
            </div>
          )}
        </ShopperListContainerStyled>
      </div>
      <div>
        <div style={{ textAlign: "center", marginBottom: 20 }}>
          <IconBtn
            style={{ zIndex: 2, border: `1px solid #fff}` }}
            onClick={() => setIsOpenDialog(true)}
          >
            add
          </IconBtn>{" "}
          <b>Click to CheckIn</b>
        </div>

        <ShopperListContainerStyled>
          {shoppersToDisplay.map((shopper) => {
            return (
              <ShopperProfile
                key={shopper._id + "shoopers_list"}
                shopper={shopper}
                isActive={!!shopper.in}
                onClick={() => {
                  api({
                    type: "siteCheckin",
                    data: {
                      userId: shopper._id,
                      siteId,
                    },
                  });
                }}
              />
            );
          })}
        </ShopperListContainerStyled>
      </div>
<div>isOpenDialog ${isOpenDialog}</div>
      {isOpenDialog && (
                <ShopperAddDialog
                    open={isOpenDialog}
                    shopper={editShopper}
                    onClose={() => {
                        setEditShopper(null);
                        setIsOpenDialog(false);
                    }}
                    onNewShopper={(newShopper, isEdit) => {
                        let newShoppersList = [];
                        if (isEdit) {
                            newShoppersList = shoppers.map(shopper => {
                                if (shopper._id === newShopper._id) {
                                    return newShopper;
                                }
                                return shopper;
                            });
                        } else {
                            shoppers.unshift(newShopper);
                            newShoppersList = shoppers;
                        }
                        setShoppers(newShoppersList);
                        setEditShopper(null);
                        setIsOpenDialog(false);
                    }}
                />
            )}
            
    </WrapperStyled>

    
  );
};

export default ShopperCheckinDrawer;
